import React, { useState, useEffect, useContext } from 'react'
import firebase from 'firebase'
import LinkUI from './LinkUI'
import phone_view from '../../images/phone_view.jpg'
function Links(props) {
    const [obj, setObj] = useState({})
    const [arrayOfLinks, setArrayOfLinks] = useState([])
    const [linkid, setLinkId] = useState('')
    const uid = props.user
    useEffect(
        () => {
            let isSubscribed = true;
            if (isSubscribed) { setObj({}) }
            firebase.database().ref().get().then(s => {
                let id = s.child('users').child(uid).child('linkid').val() || uid
                if (isSubscribed) {
                    setLinkId(id)
                }
                let linkobj = s.child(id).child('links').val()
                if (isSubscribed) {
                    setObj(linkobj)
                }
            })
            return () => { isSubscribed = false }
        }, [])
    useEffect(
        () => {
            let isSubscribed = true;
            if (obj !== {}) {
                let array = []
                for (let ele in obj) {
                    array.push({ name: ele, link: obj[ele] })
                }
                console.log(obj)
                if (isSubscribed) { setArrayOfLinks(array) }
            }
            return () => { isSubscribed = false }

        }, [obj]
    )
    return (
        <>
            <div className='row'>
                <div className='col-xl-6 col-md-6 col-sm-11 col-xs-11 mr-3'>
                    {arrayOfLinks !== [] || arrayOfLinks.length !== 0 || arrayOfLinks !== null || obj !== null || obj !== {} ?
                        arrayOfLinks.map(ele =>
                            <div key={`${ele.name}${uid}`}>
                                <LinkUI
                                    name={ele.name}
                                    link1={ele.link}
                                    isInEditLink={true}
                                    linkid={linkid}
                                />
                            </div>
                        )
                        :
                        <h4 className='text-primary'>Nothing to show here...</h4>
                    }
                </div>
                <div className='col-1 ' />
                <div className='col-md-4 col-xl-4 col-xs-12 col-sm-8 mt-4'>
                    <div className='text-center h2 text-primary '>Preview</div>
                    <img className='img-fluid mt-2' src={phone_view}></img>
                </div>
            </div>
        </>
    )
}

export default Links




